<template>
  <div
    id="loader"
    class="w-fit flex flex-row justify-center items-center gap-2"
  >
    <div
      class="default-spinner"
      :style="{
        width: `${size}px`,
        height: `${size}px`,
        borderWidth: `${borderWidth}px`,
        borderTopWidth: `${borderWidth}px`,
      }"
    ></div>

    <span v-if="showLabel" class="text-base text_color proxima_nova">{{
      text
    }}</span>
  </div>
</template>

<script>
export default {
  name: "CustomLoader",
  props: {
    size: {
      type: Number,
      default: 40,
    },
    text: {
      type: String,
      required: false,
      default: "Loading..",
    },
    showLabel : {
      type: Boolean,
      required: false,
      default: true
    },
    borderWidth: {
      type: Number,
      default: 4,
    },
  },
};
</script>

<style scoped>
.default-spinner {
  border-color: var(--white-opacity-10);
  border-top-color: var(--text-color);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
